

















































import { Vue, Component, Watch } from 'vue-property-decorator'
// Components
import TheAppBar from '@/modules/shared/components/TheAppBar'
import JoinableMatchBar from '@/modules/match/components/JoinableMatchBar'
import AuthDialog from '@/modules/auth/components/AuthDialog'
import ReconnectDialog from '@/modules/shared/components/ReconnectDialog'
import TournamentTeamTokenDialog from '@/modules/tournament/components/TournamentTeamTokenDialog'
import AccountSidebar from '@/modules/auth/components/AccountSidebar'
import SearchDialog from '@/modules/shared/components/SearchDialog'
import JoinableMatchMobile from '@/modules/match/components/JoinableMatchMobile'
import UpdateDialog from '@/modules/shared/components/UpdateDialog/UpdateDialog.vue'
import JoinTournamentSetDiscordIdDialog from '@/modules/member/components/JoinTournamentSetDiscordIdDialog'
// Store
import layoutStore from '@/modules/shared/layout.store'
import userStore from '@/modules/auth/auth.store'
import tournamentStore from '@/modules/tournament/tournament.store'
// Misc
import { getModule } from 'vuex-module-decorators'
import { getRealtimeConnection, realtimeEventTarget } from '@/utils/realtime'
import { HubConnection } from '@microsoft/signalr'
import { CancelError, CancellationToken } from '@/utils/cancel'
import MemberOnboardActionDialog from '@/modules/member/components/MemberOnboardActionDialog/MemberOnboardActionDialog.vue'
import PhoneNumberVerificationDialog from '@/modules/member/components/PhoneNumberVerificationDialog'

@Component({
  components: {
    PhoneNumberVerificationDialog,
    AuthDialog,
    MemberOnboardActionDialog,
    UpdateDialog,
    SearchDialog,
    TheAppBar,
    JoinableMatchBar,
    JoinableMatchMobile,
    TournamentTeamTokenDialog,
    ReconnectDialog,
    AccountSidebar,
    JoinTournamentSetDiscordIdDialog
  }
})
export default class AppLayout extends Vue {
  realtimeConnection!: HubConnection
  realtimeConnectionCancellationToken = new CancellationToken()

  layoutModule = getModule(layoutStore, this.$store)
  userModule = getModule(userStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)

  isOnboarding: boolean = false

  get hasLoggedIn(): boolean {
    return this.userModule.hasLoggedIn
  }

  get isProgressBarVisible() {
    return this.layoutModule.progressBarVisible
  }

  get nickname() {
    return this.userModule.nickname
  }

  get userId() {
    return this.userModule.userId
  }

  get isDesktopView() {
    return !this.$vuetify.breakpoint.mobile // this.isMatch
  }

  get isMatch() {
    return this.$route.name && this.$route.name === 'Match'
  }

  get isNewMember() {
    return this.userModule.isNewMember
  }

  /* Methods */
  onTournamentCatalogUpdated() {
    if (
      this.$router.currentRoute &&
      this.$router.currentRoute.name !== 'Landing'
    ) {
      this.tournamentModule.clearTournamentCatalog()
    }
  }

  /* Hooks */
  async created() {
    await this.subscribeRealtimeEvents()
    realtimeEventTarget.addEventListener(
      'connect',
      this.subscribeRealtimeEvents
    )
    realtimeEventTarget.addEventListener(
      'reconnected',
      this.subscribeRealtimeEvents
    )
    this.isOnboarding = this.hasLoggedIn && this.isNewMember
  }

  async beforeDestroy() {
    this.unsubscribeRealtimeEvents()
    realtimeEventTarget.removeEventListener(
      'connect',
      this.subscribeRealtimeEvents
    )
    realtimeEventTarget.removeEventListener(
      'reconnected',
      this.subscribeRealtimeEvents
    )
  }

  async subscribeRealtimeEvents() {
    try {
      this.realtimeConnection = await getRealtimeConnection(
        this.realtimeConnectionCancellationToken
      )
    } catch (err) {
      if (err instanceof CancelError) {
        return
      }

      this.$toast.error(this.$t('AppLayout.FailConnectServerMessage'))
      console.error(err)
    }
    this.realtimeConnection.on(
      'tournamentCatalogUpdated',
      this.onTournamentCatalogUpdated
    )
  }

  unsubscribeRealtimeEvents() {
    this.realtimeConnectionCancellationToken.cancel()
    if (this.realtimeConnection) {
      this.realtimeConnection.off(
        'tournamentCatalogUpdated',
        this.onTournamentCatalogUpdated
      )
    }
  }

  @Watch('isNewMember')
  onIsNewMemberChanged(value: boolean) {
    if (value) {
      this.isOnboarding = true
    }
  }
}
